
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/instructional-shifts-that-stick",
      function () {
        return require("private-next-pages/c/blog-posts/instructional-shifts-that-stick.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/instructional-shifts-that-stick"])
      });
    }
  